import { render } from "./Header.LeftDrawer.vue?vue&type=template&id=4be2b008&scoped=true"
import script from "./Header.LeftDrawer.vue?vue&type=script&lang=ts"
export * from "./Header.LeftDrawer.vue?vue&type=script&lang=ts"

import "./Header.LeftDrawer.vue?vue&type=style&index=0&id=4be2b008&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4be2b008"

export default script